module.exports = __webpack_public_path__ + "img/hor1.fed6f777.jpg";